<template>
    <v-container>
      <h1>Liste des employés</h1>
            <v-btn
        class="mb-3"
        color="secondary"
        @click="generatePDF()"
      >
        <v-icon left>  
          mdi-file-pdf-box
        </v-icon>
        Télécharger en PDF
      </v-btn>
      <v-row>
        <v-col cols="12"
              md="6">
          <CheckBoxGroup
                v-bind:data="fonctions"
                name="fonctions"
                title="Fonctions"
                idprop="id"
                nameprop="nom"
                @newselection="filter($event)"
              ></CheckBoxGroup>
        </v-col>
        <v-col cols="12"
              md="6">
          <CheckBoxGroup
          v-bind:data="sites"
          name="sites"
          title="Sites"
          idprop="id"
          nameprop="nom"
          @newselection="filter($event)"
        ></CheckBoxGroup>
        </v-col>
      </v-row>

      <v-data-table
        :headers="fields"
        :items="filteredEmployes"
        :items-per-page="10"
        class="elevation-1"
        :loading="loading"
        loading-text="Chargement..."
      >
      <template v-slot:item.fonction="{ item }">
          <span
              v-for="fonction in item.fonctions"
              v-bind:key="fonction"
            >{{fonctionsById[fonction].nom}}&nbsp;</span>
      </template>
      <template v-slot:item.site="{item}">{{sitesById[item.id_site].nom}}</template>      
      </v-data-table>
    </v-container>
</template>

<script>
import api from "@/api";
import CheckBoxGroup from "../components/CheckBoxGroup";
import store from "@/store";

export default {
  data() {
    return {
      fonctions: [],
      fonctionsById: [],
      sites: [],
      sitesById: [],
      employes: [],
      filters: {
        sites: [],
        fonctions: []
      },
      perPage: 15,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      fields: [
        { value: "nom", text: "Nom", sortable: true },
        { value: "prenom", text: "Prénom", sortable: true },
        { value: "tel", text: "Téléphone", sortable: false },
        { value: "fonction", text: "Fonction(s)", sortable: false },
        { value: "site", text: "Site", sortable: false }
      ]
    };
  },
  components: {
    CheckBoxGroup
  },
  async created() {
    this.loadData();
  },
  methods: {
    async loadData(){
      this.$store.commit("setLoading", true);
      this.fonctions = (await api.getFonctions()).data.fonctions;
      for (let fonction of this.fonctions) {
        this.fonctionsById[fonction.id] = fonction;
      }
      this.sites = (await api.getSites()).data.sites;
      for (let site of this.sites) {
        this.sitesById[site.id] = site;
      }
      this.employes = (await api.getEmployes()).data.employes;
      this.$store.commit("setLoading", false);
    },
    filter(e) {
      this.filters[e.name] = e.selected;
    },
    generatePDF() {
      api.pdf(`employes`, { filters: this.filters }, `employes`);
    },
  },
  computed: {
    loading() {
      return store.state.loading;
    },
    filteredEmployes() {
      return this.employes.filter(employe => {
        let sitematch = 0;
        for (let site of this.filters.sites) {
          if (site === employe.id_site) sitematch++;
        }
        let fonctionmatch = 0;
        for (let id_fonction of employe.fonctions) {
          for (let fonction of this.filters.fonctions) {
            if (fonction === id_fonction) fonctionmatch++;
          }
        }
        if (sitematch > 0 && fonctionmatch > 0) {
          return employe;
        }
      });
    }
  }
};
</script>